import { Button, Icon, icons, Typography, theme } from "cdh-data-portal-theme"
import { getSignInUrl } from "../../../api/authenticationApi"
import { useStyles } from "./Login.style"
import { localText } from "./Login.static"

export interface LoginProps {
  readonly redirectAfterLoginUrl?: string | null
}

export const Login: React.FC<LoginProps> = ({ redirectAfterLoginUrl = null }) => {
  const { classes } = useStyles()

  return (
    <div className={classes.root}>
      <div className={classes.loginContainer}>
        <Icon
          iconPath={{ path: icons.portalLogo.path, viewBox: "0 0 64 64" }}
          color={theme.colors.primary}
          size={40}
        />
        <Typography variant="headline2" className={classes.title}>{localText.title}</Typography>
        <Typography variant="body" className={classes.subtitle} color={theme.textColors.primaryLighter}>
          {localText.subtitle}
        </Typography>
        <Button
          url={getSignInUrl({ returnPath: redirectAfterLoginUrl })}
          openLinkInNewTab={false}
          variant="primary"
          title={localText.loginButton}
          width={260}
        />
      </div>
    </div>
  )
}

export default Login
